import { render, staticRenderFns } from "./AddCriteria.vue?vue&type=template&id=d83bcd0c&scoped=true&"
import script from "./AddCriteria.vue?vue&type=script&lang=js&"
export * from "./AddCriteria.vue?vue&type=script&lang=js&"
import style0 from "./AddCriteria.vue?vue&type=style&index=0&id=d83bcd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83bcd0c",
  null
  
)

export default component.exports